import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Shareable from '@shared/models/shareable';
import pick from 'lodash.pick'; // This represents a single Google/Outlook calendar

var ImportedCalendar = /*#__PURE__*/function (_Shareable) {
  _inherits(ImportedCalendar, _Shareable);

  var _super = _createSuper(ImportedCalendar);

  function ImportedCalendar() {
    _classCallCheck(this, ImportedCalendar);

    return _super.apply(this, arguments);
  }

  _createClass(ImportedCalendar, [{
    key: "withVisibility",
    value: function withVisibility(visibility) {
      var clone = this.clone();
      clone.visible = visibility;
      return clone;
    }
  }, {
    key: "withType",
    value: function withType(type) {
      var clone = this.clone();
      clone.calendarType = type;
      return clone;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.id === other.id;
    }
  }], [{
    key: "fromPlainObject",
    value: function fromPlainObject(obj) {
      if (!obj) {
        return new NullImportedCalendar();
      }

      var calendar = new this();
      Object.assign(calendar, pick(obj, this.shareableFields()));
      return calendar;
    }
  }, {
    key: "shareableFields",
    value: function shareableFields() {
      return ['id', 'calendarType', 'summary', 'visible', 'timeZone'];
    }
  }]);

  return ImportedCalendar;
}(Shareable);

export { ImportedCalendar as default };
export var NullImportedCalendar = /*#__PURE__*/function (_ImportedCalendar) {
  _inherits(NullImportedCalendar, _ImportedCalendar);

  var _super2 = _createSuper(NullImportedCalendar);

  function NullImportedCalendar() {
    _classCallCheck(this, NullImportedCalendar);

    return _super2.apply(this, arguments);
  }

  _createClass(NullImportedCalendar, [{
    key: "withVisibility",
    value: function withVisibility() {
      return this;
    }
  }, {
    key: "withType",
    value: function withType() {
      return this;
    }
  }]);

  return NullImportedCalendar;
}(ImportedCalendar);